import * as React from "react";
import InfoModule from "../../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import RemovableList from "../../../../hiberUiKit/src/molecules/RemovableList/RemovableList";
import SearchDropDown from "../../../../hiberUiKit/src/molecules/SearchDropDown/SearchDropDown";
import DropDownWrapper from "../../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import DictionaryItem from "../../../../model/dictionary/DictionaryItem";

interface IProps {
	/**
	 * All categories.
	 */
	availableCategories: DictionaryItem[];
	/**
	 * Currently selected categories.
	 */
	currentCategories: DictionaryItem[];
	/**
	 * On select category action callback.
	 * @param {DictionaryItem} category
	 */
	onSelect: (category: DictionaryItem) => void;
	/**
	 * On remove category action callback.
	 * @param {DictionaryItem} category
	 */
	onRemove: (category: DictionaryItem) => void;
}


interface IState {
	dropDownVisible: boolean;
}

type Props = IProps

export class ReasonForContact extends React.PureComponent<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.state = {dropDownVisible: false};
		this.toggleDropdown = this.toggleDropdown.bind(this);
		this.onSelect = this.onSelect.bind(this);
	}

	render() {
		return (
			<InfoModule icon={Icon.Phone} title={"Reason for contact"} actionIcon={Icon.Add}
						onActionIconClick={this.toggleDropdown}>
				{this.state.dropDownVisible &&
				<DropDownWrapper onOutsideClick={() => {this.setState({dropDownVisible: false})}}>
					<SearchDropDown items={this.props.availableCategories}
									onChange={this.onSelect}
									itemToLabel={(category: DictionaryItem) => category.name}
									itemToId={(category: DictionaryItem) => category.id}
									searchInputIcon={Icon.Phone}/>
				</DropDownWrapper>
				}
				{
					this.props.currentCategories.length ?
						<RemovableList onRemove={this.props.onRemove}
									   items={this.props.currentCategories}
									   itemRowRenderer={(category: DictionaryItem) => category ? category.name : "Unnamed"}/>
						:
						<span className={"t-body"}>Not provided</span>
				}
			</InfoModule>
		);
	}

	toggleDropdown() {
		this.setState({dropDownVisible: !this.state.dropDownVisible});
	}

	onSelect(category: DictionaryItem) {
		this.setState({dropDownVisible: !this.state.dropDownVisible}, () => this.props.onSelect(category));
	}
}